module.exports = __webpack_public_path__ + "not-recognized-marker.d7760bc5044fd59e696292820f08adff.svg";